"use strict";
import mediumStyles from "../src/spectrum-two/scale-medium.css.js";
import { Theme } from "../src/Theme.dev.js";
import "../src/spectrum-two/core.dev.js";
Theme.registerThemeFragment("medium-spectrum-two", "scale", mediumStyles);
//# sourceMappingURL=scale-medium.dev.js.map
